/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import styled from 'styled-components';
import { Draggable } from 'react-beautiful-dnd';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';

function Item(props) {
  const {
    item, checked, handleToggle, optionLabel, suggested, setSuggested, index,
  } = props;
  const [check, setCheck] = useState(suggested[item] !== undefined ? suggested[item] : false);

  const numindex = index + 1;

  const handleChange = (event) => {
    const ret = event.target.name.replace('Check-', '');
    setSuggested({ id: ret, value: event.target.checked });
    setCheck(event.target.checked);
  };
  const StyledContainer = styled.div`
    width: 95%;
    cursor: ${() => (props.isDragging ? 'grab;' : 'pointer;')}  
    border: ${() => (props.isDragging ? '1px solid rgba(0, 0, 0, 0.6);' : '1px solid rgba(0, 0, 0, 0.3);')}
    border-radius: 1px;
    background-color: white;
    margin: 10px;
`;
  const labelId = `transfer-list-all-item-${item}-label`;
  if (optionLabel && optionLabel[item]) {
    return (
      <Draggable draggableId={`${index}`} index={index}>
        {(provided, snapshot) => (
          <StyledContainer
            ref={provided.innerRef}
            isDragging={snapshot.isDragging}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <ListItem key={item} role="listitem" button>
              <Typography onClick={handleToggle(item)} style={{ width: '10px' }}>{numindex}</Typography>
              <ListItemIcon onClick={handleToggle(item)}>
                <Checkbox
                  name={`CoursplanList-${item}`}
                  checked={checked.indexOf(item) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText onClick={handleToggle(item)} id={labelId} primary={`${optionLabel[item].label}`} />
              <Switch
                checked={check}
                onChange={handleChange}
                name={`Check-${item}`}
                inputProps={{ 'aria-label': 'secondary checkbox' }}
              />
            </ListItem>
          </StyledContainer>
        )}
      </Draggable>
    );
  }
  return (<div />);
}

Item.propTypes = {
  item: PropTypes.any.isRequired,
  checked: PropTypes.any.isRequired,
  handleToggle: PropTypes.any.isRequired,
  optionLabel: PropTypes.any.isRequired,
  suggested: PropTypes.any.isRequired,
  setSuggested: PropTypes.any.isRequired,
  index: PropTypes.any.isRequired,
  isDragging: PropTypes.any.isRequired,
};

export default Item;
